import { companiesLogos } from "@/assets/companiesLogos";

const clientLogos = [
  { 
    name: "Sabbar", 
    image: companiesLogos["sabbar"],
    width: "w-40"
  },
  { name: "Squadio", 
    image: companiesLogos["squadio"],
     width: "w-40"
  },
  { name: 
    "Midaia", 
    image: companiesLogos["midaia"],  
    width: "w-45" 
  },
  { name: "Velents", 
    image: companiesLogos["velents"],  
    width: "w-40" 
  },
  { 
    name: "Tru", 
    image: "", 
    width: "w-26" 
  },
];

export default clientLogos;